/* GENERATED by scripts/gen-data.mjs — chapter "x-delivery" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_DELIVERY: NodeDef = {
  "id": "x-delivery",
  "tagKey": "path:x-delivery.tag",
  "x": 1300,
  "y": 180,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-delivery.title",
  "subKey": "path:x-delivery.sub",
  "blocks": [
    {
      "id": "x-delivery.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-delivery.b1.title",
      "bodyKey": "path:x-delivery.b1.body",
      "flowKey": "path:x-delivery.b1.flow"
    },
    {
      "id": "x-delivery.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:x-delivery.b2.title",
      "film": "f-delivery"
    },
    {
      "id": "x-delivery.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-delivery.b3.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:x-delivery.b3.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:x-delivery.b3.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:x-delivery.b3.ex.items.0.why"
          },
          {
            "tKey": "path:x-delivery.b3.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:x-delivery.b3.ex.items.1.why"
          },
          {
            "tKey": "path:x-delivery.b3.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:x-delivery.b3.ex.items.2.why"
          },
          {
            "tKey": "path:x-delivery.b3.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:x-delivery.b3.ex.items.3.why"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "event-bus"
};
